<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western4" id="calibre_pb_8"><a id="Ack_1"></a> <span class="c5"><a href="#/tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_007#ref_TOC">Acknowledgements</a></span></h1>
<p class="western1"> <br class="calibre1"/></p>
<p class="c6">This didn’t start out as a novel. It was an exercise
in teaching preparedness by storytelling a what-if situation on a
day to day basis on a blog. As I got further into it, it morphed
into what it is now. There are so many to thank for their
encouragement while I was writing this:</p>
<p class="western1">The gals in my Women’s Survival group, who
pushed me for that next entry yet understood when I needed a
break;</p>
<p class="western1">To my sister, Pam, who let me bounce ideas
off her and nagged me to publish;</p>
<p class="western1">And definitely a deep thank you to Jim Cobb,
my partner in crime on SurvivalWeekly.com— which the blog called
home— who helped me find a publisher willing to take the risk on
me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_009.vue?549e78a5